import { render, staticRenderFns } from "./DepartmentTreeSelect.vue?vue&type=template&id=eca41786&scoped=true"
import script from "./DepartmentTreeSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepartmentTreeSelect.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DepartmentTreeSelect.vue?vue&type=style&index=0&id=eca41786&prod&scoped=true&lang=scss"
import style1 from "./DepartmentTreeSelect.vue?vue&type=style&index=1&id=eca41786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca41786",
  null
  
)

export default component.exports